var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableRateButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.816,
    height: 15.816,
    viewBox: "0 0 15.816 15.816",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Discount",
    transform: "translate(0 0.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke_1",
    "data-name": "Stroke 1",
    d: "M1.565,3.3A1.732,1.732,0,0,1,3.3,1.565h.788a1.732,1.732,0,0,0,1.22-.5L5.855.51A1.732,1.732,0,0,1,8.3.5L8.31.51l.551.551a1.729,1.729,0,0,0,1.22.5h.787A1.732,1.732,0,0,1,12.6,3.3v.786A1.731,1.731,0,0,0,13.1,5.3l.551.551A1.732,1.732,0,0,1,13.662,8.3l-.007.007-.551.551a1.727,1.727,0,0,0-.5,1.219v.788A1.732,1.732,0,0,1,10.869,12.6h-.787a1.73,1.73,0,0,0-1.22.5l-.551.551a1.731,1.731,0,0,1-2.449.007l-.007-.007L5.3,13.1a1.733,1.733,0,0,0-1.22-.5H3.3a1.732,1.732,0,0,1-1.731-1.731v-.788a1.728,1.728,0,0,0-.5-1.219L.511,8.311A1.731,1.731,0,0,1,.5,5.862l.007-.007L1.061,5.3a1.732,1.732,0,0,0,.5-1.221V3.3",
    transform: "translate(0.75 0.751)",
    fill: "none",
    stroke: "#00b224",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_3",
    "data-name": "Stroke 3",
    d: "M0,3.936,3.936,0",
    transform: "translate(5.865 5.865)",
    fill: "none",
    stroke: "#00b224",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_5",
    "data-name": "Fill 5",
    d: "M.574,1.141A.574.574,0,0,1,.168.972.629.629,0,0,1,.046.781.511.511,0,0,1,0,.567.549.549,0,0,1,.046.345.594.594,0,0,1,.168.161a.593.593,0,0,1,.812,0,.618.618,0,0,1,.13.184.711.711,0,0,1,.038.222A.661.661,0,0,1,1.11.781.652.652,0,0,1,.98.972a.574.574,0,0,1-.406.168",
    transform: "translate(9.224 9.236)",
    fill: "#00b224"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_7",
    "data-name": "Fill 7",
    d: "M.574,1.142A.515.515,0,0,1,.36,1.095.627.627,0,0,1,.168.973.738.738,0,0,1,.046.782.516.516,0,0,1,0,.567.547.547,0,0,1,.046.345.516.516,0,0,1,.168.161a.591.591,0,0,1,.812,0,.572.572,0,0,1,.168.406A.51.51,0,0,1,1.11.782.771.771,0,0,1,.98.973.592.592,0,0,1,.8,1.095a.55.55,0,0,1-.222.047",
    transform: "translate(5.288 5.3)",
    fill: "#00b224"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableRateButton);
export default __webpack_public_path__ + "static/media/table-rate-button.be283176098136e00bd15c8fa85852f3.svg";
export { ForwardRef as ReactComponent };